import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setSearchProviderSorting } from '../../../../../redux/admin/priceCompareSlice';
import AutoSuggestionSelectComponent from '../../../common/auto-suggestion-select/Select';
const options = [
  { label: 'Best Match', value: 'Distance' },
  { label: 'A-Z', value: 'A-Z' },
  { label: 'Z-A', value: 'Z-A' },
];
export const BestMatchFilter = ({ value, valueLabel }) => {
  const dispatch = useDispatch();
  const { sortby, sortdirection } = useSelector(
    ({ priceCompareAdmin }) => priceCompareAdmin.searchProviderParams,
  );

  const allFilters = useSelector(
    ({ priceCompareAdmin }) => priceCompareAdmin.searchProviderParams.filters,
  );

  const { Provider } = allFilters;
  const selectedValue =
    sortby === 'Distance'
      ? options[0]
      : sortdirection === 'asc'
      ? options[1]
      : options[2];

  const onChange = (event) => {
    const sortByKey =
      event.value === 'Distance'
        ? 'Distance'
        : Provider === 'facility'
        ? 'facilityname'
        : 'lastName';

    const direction =
      event.value === 'Distance' || event.value === 'A-Z' ? 'asc' : 'desc';

    dispatch(
      setSearchProviderSorting({ sortby: sortByKey, sortdirection: direction }),
    );
  };

  return (
    <AutoSuggestionSelectComponent
      options={options}
      components={{ IndicatorSeparator: () => null }}
      inputClassName="best-match-filter height-32"
      value={selectedValue}
      onChange={onChange}
      isSearchable={false}
    />
  );
};
